import { useSelector, useDispatch } from 'react-redux';
import {
  fetchAssemblyData,
  fetchAssemblyDetails,
  uploadNDTDocument,
  updateAssemblyStatus,
  fetchAssemblyFilters,
  clearAssemblyData,
  clearAssemblyDetails,
  generateProjectProductionSheetReport,
  clearProjectProductionSheetReport
} from '../actions';

export const useProductionData = () => {
  const dispatch = useDispatch();
  const productionData = useSelector(state => state.productionData);

  return {
    // State
    assemblyData: productionData.assemblyData,
    assemblyTotalCount: productionData.assemblyTotalCount,
    assemblyLoading: productionData.assemblyLoading,
    assemblyError: productionData.assemblyError,
    
    assemblyDetails: productionData.assemblyDetails,
    assemblyDetailsLoading: productionData.assemblyDetailsLoading,
    assemblyDetailsError: productionData.assemblyDetailsError,
    
    ndtUploadLoading: productionData.ndtUploadLoading,
    ndtUploadError: productionData.ndtUploadError,
    
    statusUpdateLoading: productionData.statusUpdateLoading,
    statusUpdateError: productionData.statusUpdateError,
    
    assemblyFilters: productionData.assemblyFilters,
    filtersLoading: productionData.filtersLoading,
    filtersError: productionData.filtersError,

    projectProductionSheetReportLoading: productionData.projectProductionSheetReportLoading,
    projectProductionSheetReportData: productionData.projectProductionSheetReportData,
    projectProductionSheetReportError: productionData.projectProductionSheetReportError,
    projectProductionSheetReportSuccess: productionData.projectProductionSheetReportSuccess,

    // Actions
    fetchAssemblyData: (payload) => 
      dispatch(fetchAssemblyData(payload)),
    
    fetchAssemblyDetails: (payload) => 
      dispatch(fetchAssemblyDetails(payload)),
    
    uploadNDTDocument: (payload) => 
      dispatch(uploadNDTDocument(payload)),
    
    updateAssemblyStatus: (payload) => 
      dispatch(updateAssemblyStatus(payload)),
    
    fetchAssemblyFilters: (payload) => 
      dispatch(fetchAssemblyFilters(payload)),
    
    clearAssemblyData: () => 
      dispatch(clearAssemblyData()),
    
    clearAssemblyDetails: () => 
      dispatch(clearAssemblyDetails()),
    
    generateProjectProductionSheetReport: (payload) => 
      dispatch(generateProjectProductionSheetReport(payload)),
    
    clearProjectProductionSheetReport: () => 
      dispatch(clearProjectProductionSheetReport())
  };
}; 